import Box from "@mui/material/Box/Box";
import styled from "styled-components";

export const Content = styled(Box)`
  width: 100%;
  height: 100%;
  padding-top: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  width: 100%;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`;

export const FirstForm = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  width: 100%;
`;

export const SecondForm = styled.div`
  display: flex;
  flex-direction: column;
  height: fit-content;
  gap: 12px;
  justify-content: space-between;
  width: 100%;
  ${(props) => props.theme.breakpoints.up("mobile")} {
    height: 100%;
  }
`;

export const PaymentOptions = styled(Box)`
  display: flex;
  flex-direction: column;
`;
